<template>
  <div class="relative">
    <v-skeleton-loader
      v-if="isLoading"
      type="image"
      style="border-radius: 50%"
      :width="size"
      :height="size"
    />
    <v-avatar v-else :size="`${size} !important`">
      <div
        class="d-flex justify-center align-center avatar-content"
        :class="backgroundColor"
      >
        <span
          class="name-letters font-weight-medium white--text"
          :style="{ 'font-size': fontSize }"
          >{{ number }}</span
        >
      </div>
    </v-avatar>
  </div>
</template>

<script>
export default {
  name: 'NumberAvatar',

  props: {
    size: {
      type: String,
      required: false,
      default: '108px',
    },
    fontSize: {
      type: String,
      required: false,
      default: '35px',
    },
    number: {
      type: Number,
      default: 2,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    backgroundColor() {
      switch (this.number) {
        case 2:
          return 'teal darken-1'
        case 3:
          return 'red'
        case 4:
          return 'green'
        case 5:
          return 'red lighten-1'
        case 6:
          return 'blue lighten-1'
        case 7:
          return 'red darken-1'
        case 8:
          return 'red'
        case 9:
          return 'purple darken-1'
        case 10:
          return 'yellow'
        case 11:
          return 'orange'
        case 12:
          return 'yellow darken-1'
        case 13:
          return 'teal'
        case 14:
          return 'blue darken-1'
        case 15:
          return 'yellow'
        case 16:
          return 'orange darken-1'
        case 17:
          return 'red lighten-1'
        case 18:
          return 'orange'
        case 19:
          return 'teal'
        case 20:
          return 'teal darken-1'
        case 21:
          return 'blue-grey darken-1'
        case 22:
          return 'green'
        case 23:
          return 'purple darken-1'
        case 24:
          return 'purple'
        case 25:
          return 'blue lighten-1'
        case 26:
          return 'orange lighten-1'
        case 27:
          return 'red'
        case 28:
          return 'blue-grey'
        case 29:
          return 'blue'
        case 30:
          return 'green'
        default:
          return 'blue'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-content {
  width: 100%;
  height: 100%;
}
</style>
